module.exports = __webpack_public_path__ + "img/18.103.C.57eba460.png";